module.exports = __webpack_public_path__ + "static/img/shezhi_gerenziliao.571ffa17.png";